module.exports = __webpack_public_path__ + "assets/img/warehouse_0.aab9e3ff.svg";